import PATHS from './pathRoutes';

export const SECTIONS_WITHOUT_ONCLICK = [
  PATHS.privacy,
  PATHS.termAndUses,
  PATHS.help,
];
